import {initState} from "../contexts/initState";
import {
    USER_SIGN_OUT,
    USER_STATE_SAVE,
    LOAD_USER
} from "../actions";

const save_user_state = (state, {node, data}) => {
    return node !== "" ? {
        ...state,
        [node]: data,
    } : {
        ...state,
        ...data,
    };
};

const sign_out_user = (state, {}) => {
    return {
        ...state,
        ...initState,
    };
};

const load_user = (state, changes) => {
    return {
        ...state,
        ...changes,
    };
};

export default (state, action) => {
    switch (action.type) {
        case LOAD_USER:
            return load_user(state, action);
        case USER_SIGN_OUT:
            return sign_out_user(state, action);
        case USER_STATE_SAVE:
            return save_user_state(state, action);
        default:
            return state;
    }
};
